import { request, METHOD } from '@/utils/request'
import { BASE_URL } from '@/config/public'

export async function rqtPostDefCodeList(params) {
  return request(
    `${BASE_URL}/provider/common/defcode/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtGetDefCodeList(params) {
  return request(
    `${BASE_URL}/provider/common/defcode/lists`,
    METHOD.GET_PARAM_ARRAY,
    params
  )
}
